import { Switch } from "@mantine/core"
import { Badge, Icon, IndexTable } from "@shopify/polaris"
import {
	DeleteMajor,
	EditMajor,
	MobileHorizontalDotsMajor,
} from "@shopify/polaris-icons"
import React from "react"
import { useTranslation } from "react-i18next"

const GeolocationRedirectEntry = ({
	redirectEntryIndex,
	redirectEntry,
	onEdit,
	onDelete,
	onToggle,
}) => {
	const [t] = useTranslation()

	return (
		<IndexTable.Row
			position={redirectEntryIndex}
			status={redirectEntry.active ? "success" : "subdued"}
		>
			<IndexTable.Cell>
				<Switch
					checked={redirectEntry.active}
					onChange={() => onToggle(redirectEntryIndex)}
					onLabel="ON"
					offLabel="OFF"
				/>
			</IndexTable.Cell>

			<IndexTable.Cell>
				<p
					style={{
						textOverflow: "ellipsis",
						maxWidth: "8rem",
						overflow: "hidden",
						fontSize: "0.9rem",
					}}
				>
					{redirectEntry.title}
				</p>
			</IndexTable.Cell>

			<IndexTable.Cell>
				<a
					href={redirectEntry.redirectTo}
					rel="noreferrer"
					target="_blank"
					style={{ fontSize: "0.9rem" }}
				>
					{redirectEntry.redirectTo}
				</a>
			</IndexTable.Cell>

			<IndexTable.Cell>
				<div style={{ display: "flex", gap: "3px" }}>
					{redirectEntry.countriesAndIpsToRedirect
						.slice(0, 3)
						?.map((countryOrIp, i) => (
							<Badge key={i} progress="complete">
								{countryOrIp}
							</Badge>
						))}

					{redirectEntry.countriesAndIpsToRedirect.length > 3 && (
						<Badge>
							<Icon
								source={MobileHorizontalDotsMajor}
								color="base"
							/>
						</Badge>
					)}
				</div>
			</IndexTable.Cell>

			<IndexTable.Cell>
				<p style={{ fontSize: "0.9rem" }}>
					{redirectEntry.maintainPath
						? t("common.yes")
						: t("common.no")}
				</p>
			</IndexTable.Cell>

			<IndexTable.Cell>
				<div
					onClick={() => onEdit(redirectEntryIndex)}
					style={{
						width: "1.8rem",
						height: "1.8rem",
						cursor: "pointer",
					}}
				>
					<Icon source={EditMajor} color="subdued" />
				</div>
			</IndexTable.Cell>

			<IndexTable.Cell>
				<div
					onClick={() => onDelete(redirectEntryIndex)}
					style={{
						width: "1.8rem",
						height: "1.8rem",
						cursor: "pointer",
					}}
				>
					<Icon source={DeleteMajor} color="subdued" />
				</div>
			</IndexTable.Cell>
		</IndexTable.Row>
	)
}

export default GeolocationRedirectEntry
